module.exports = __webpack_public_path__ + "static/media/close.18445307.svg";